import { useEffect, useRef, useState } from 'react';
import audioManager from '../utils/audioManager';

const isMobile = window.innerWidth <= 620;

interface AudioPlayerProps {
  loudness: number;
  frequency: string;
  autoPlay: boolean;
  isTestScreen: boolean;
  disableButtons?: (disable: boolean) => void;
}

const AudioPlayer = ({
  loudness,
  frequency,
  autoPlay,
  isTestScreen,
  disableButtons,
}: AudioPlayerProps) => {
  const [isAudioReady, setIsAudioReady] = useState(false);
  const preloadPromiseRef = useRef<Promise<void> | null>(null);

  useEffect(() => {
    const initializeAudio = async () => {
      try {
        if (!preloadPromiseRef.current) {
          preloadPromiseRef.current = audioManager.preloadAllAudio();
          await preloadPromiseRef.current;
        }
        setIsAudioReady(true);
      } catch (error) {
        console.error('Failed to initialize audio:', error);
      }
    };

    initializeAudio();

    return () => {
      audioManager.stopAllAudio();
    };
  }, []);

  useEffect(() => {
    if (!autoPlay && isTestScreen) return;
    if (!isAudioReady) return;

    const playAudio = async () => {
      try {
        if (disableButtons && isMobile) disableButtons(true);

        const audioKey = `${frequency}_${loudness}dB.wav`;
        await audioManager.playAudio(audioKey, 1.0);

        if (disableButtons && isMobile) {
          setTimeout(() => disableButtons(false), 500);
        }
      } catch (error) {
        console.error('Failed to play audio:', error);
        if (disableButtons && isMobile) {
          disableButtons(false);
        }
      }
    };
    playAudio();
  }, [loudness, frequency, autoPlay, isTestScreen, isAudioReady, disableButtons]);

  return null;
};

export default AudioPlayer;
